/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken, getParams, removeUrlParam } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import IntegrationForm from './partials/IntegrationForm';

import './ProIntegrations.css';

import {
  fetchUser,
  listCompanies,
  addIntegration,
  pullMyData,
} from '../actions';


class BookeoIntegration extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    let params = getParams();
    let delta = {};

    console.log('DELTA params:', params);
    console.log('DELTA props:', this.props, this.props.forSystem);

    if (this.props.forSystem == 'bookeo' && params.state == 'bookeo') {
      delta.adding = true;
      delta.apiKey = params.apiKey;
    } else if (this.props.forSystem == 'checkfront' && params.state == 'checkfront') {
      delta.adding = true;
      delta.code = params.code;
    }
    console.log('DELTA', delta);
    this.setState(delta);
  }

  addIntegration(e, values) {
    console.log('add integration', values);
    this.props.addIntegration(values)
      .then(resp => {
        console.log('add integration resp', resp);
        if (resp.error) return;
        removeUrlParam(['state', 'apiKey']);
        this.setState({ adding: false });
        this.props.onComplete()
          .then(() => {
            NotificationManager.success('Added ' + this.props.name);
          });
      });
  }

  renderAddIntegration() {
    let company = this.props.company;
    if (!company) return;
    let name = this.props.name;

    return (
      <div>
        <Modal show={this.state.adding}>
          <Modal.Header closeButton onHide={() => this.setState({ adding: false })}>
            <Modal.Title>{name}</Modal.Title>
          </Modal.Header>
          <IntegrationForm
            modal
            errors={this.props.errors.addIntegration}
            values={{ bookingSystem: this.props.forSystem,
                      accessToken: this.state.apiKey,
                      code: this.state.code,
                      companyId: company.id
                    }}
            onSubmit={(e, values) => this.addIntegration(e, values)}
            onCancel={(e, values) => this.setState({ adding: false })}
            buttonText="Add Integration"
            cancelText="Cancel"
            company={company}
            locations={company.locations}
          />
        </Modal>
      </div>
    )
  }

  render() {
    let url = this.props.url;
    let name = this.props.name;

    return (
      <div className="bookeo">
        {this.renderAddIntegration()}
        <a href={url}><Button bsStyle="primary"><FontAwesome name="plus-square"/> {name}</Button></a>
      </div>
    );
  }
}


class ProIntegrations extends OzComponent {

  state = {};

  static need = [
    ['user', fetchUser],
    ['companies', listCompanies, p => { return [{ mine: 1 }] }],
  ];

  refresh() {
    return this.props.listCompanies({ mine: 1 }, { background: true });
  }

  renderSample() {
    if (!this.state.integrationData) return;

    let idx = 0;
    let nodes = this.state.integrationData.companies.map(company => {
      let locationNodes = company.locations.map(location => {

        let roomNodes = location.rooms.map(room => {
          let timeSlotNodes = room.timeSlots.map(timeSlot => {
            return (
              <li key={idx++}>
                {moment(timeSlot.datetime).format('MMM Do, h:mma')} - {timeSlot.status} ({timeSlot.slotsLeft} available)
              </li>
            )
          });

          return (
            <li key={idx++}>
              <div>{room.name} - ({room.extId})</div>
              <ul>{timeSlotNodes}</ul>
            </li>
          )
        });

        return (
          <li key={idx++}>
            <div>{location.address} ({location.extId})</div>
            <ul>{roomNodes}</ul>
          </li>
        );
      });

      return (
        <li key={idx++}>
          <div>({company.extId})</div>
          <ul>{locationNodes}</ul>
        </li>
      );
    });

    return (
      <div>
        <ul>{nodes}</ul>
      </div>
    );
  }

  renderIntegrations() {
    // if (!this.isOwner()) return;
    let companies = this.props.companies;
    if (!companies) return;
    let company = companies.items[0];

    let integrationNodes = company.integrations.map(integration => {
      let locationNode = null;
      if (integration.location) {
        locationNode = <span> - {integration.location.address}</span>;
      }
      return (
        <li key={integration.id} className="integration">
          <FontAwesome name="check-circle"/> {integration.bookingSystem} {locationNode} <span className="integration-type">data</span>
        </li>
      );
    });

    let showNoIntegrations = integrationNodes.length == 0;
    let showNoTimes = !showNoIntegrations && !company.hasFutureTimeSlots;

    let bookeoUrl = 'https://signin.bookeo.com/?authappid=TPUPL97WM96P&permissions=bookings_r_all,blocks_r_all,availability_r&state=bookeo';
    let bookeoBookingUrl = 'https://signin.bookeo.com/?authappid=TPUPL97WM96P&permissions=availability_r,bookings_rw_all,blocks_r_all,blocks_rw_all,customers_rw_own&state=bookeo';

    let checkfrontUrl = 'https://escapespy.checkfront.co.uk/oauth/?client_id=828689b9e54bd6862c9920456f0fe0a521a49b89&response_type=code&redirect_uri=https://www.escapespy.com/manage&state=checkfront';

    let pullSampleNode;
    if (integrationNodes.length > 0) {
      pullSampleNode = (
        <div className="pull-sample">
          <p>Test your integration by pulling sample data:</p>
          <div><Button onClick={() => this.pullSample()}>Pull Sample Data</Button></div>
        </div>
      );
    }

    let addIntegrationNode;
    if (integrationNodes.length == 0) {
      addIntegrationNode = (
        <div>
          <BookeoIntegration
            name="Bookeo Data Integration"
            forSystem="bookeo"
            url={bookeoUrl}
            onComplete={() => this.refresh()}
            company={company}
            {...this.props}
          />

          {/*<BookeoIntegration
            name="Checkfront Data Integration"
            forSystem="checkfront"
            url={checkfrontUrl}
            onComplete={() => this.refreshCompany()}
            company={company}
            {...this.props}
          />*/}
        </div>
      );
    }

    let hasBookingIntegration = false;
    let bookingIntegrationNodes = [];
    for (let integration of company.integrations) {
      if (integration.permissions.includes('booking')) {
        hasBookingIntegration = true;
        let locationNode = null;
        if (integration.location) {
          locationNode = <span> - {integration.location.address}</span>;
        }
        let node = (
          <li key={integration.id} className="integration">
            <FontAwesome name="check-circle"/> {integration.bookingSystem} {locationNode} <span className="integration-type">booking</span>
          </li>
        );
        bookingIntegrationNodes.push(node);
      }
    }

    let addBookingIntegrationNode;
    if (false && !hasBookingIntegration) {
      addBookingIntegrationNode = (
        <div>
          <BookeoIntegration
            name="Bookeo Booking Integration"
            forSystem="bookeo"
            url={bookeoBookingUrl}
            onComplete={() => this.refreshCompany()}
            {...this.props}
          />
        </div>
      );
    }

    return (
      <div>
        {showNoIntegrations && <div className="no-integrations">
         <div className="no-integrations-header"><FontAwesome name="exclamation-triangle"/> No booking system connected</div>
         <div className="no-integrations-sub">Connect booking system below to ensure an up-to-date listing.</div>
         </div>}

        {showNoTimes && <div className="no-times">
         <div className="no-times-header"><FontAwesome name="exclamation-triangle"/> No time slots found for {company.name}</div>
         <div className="no-times-sub">Contact support using the chat box to fix this.</div>
         </div>}

        <div className="company-sources integration-sources">
          <div className="gray-small-caps-header">Data Integrations</div>
          {integrationNodes.length == 0 && <div><p>Connect your booking system to import all your rooms and time slots. This will ensure that your listings on EscapeSpy are always up to day, and you never have to worry about updating them on different websites.</p><p>This is a read-only integration, and your data will not be modified in any way.</p></div>}
          {integrationNodes.length > 0 && <div>
           <p>You have added these integrations for time slot information.</p>
           <ul>{integrationNodes}</ul>
           </div>}

           {pullSampleNode}
           {this.renderSample()}

           {addIntegrationNode}
        </div>

        <div className="company-sources integration-sources">
          <div className="gray-small-caps-header">Booking Integration</div>
          <div>
            <p>
              Allow players to book times directly on EscapeSpy.
            </p>
          </div>
          <div><ul>{bookingIntegrationNodes}</ul></div>
          {addBookingIntegrationNode}
          {/*this.renderStripe()*/}
        </div>
      </div>
    );
  }

  pullSample() {
    this.props.pullMyData()
      .then(resp => {
        console.log('pullMyData:', resp);
        this.setState({ integrationData: resp });
        this.refresh();
      });
  }

  render() {
    return (
      <Wrapper className="ProIntegrations" helmet="Integrations" padded pro>
        <div className="pro-header">Integrations</div>
        {this.renderIntegrations()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    companies: state.list.company,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listCompanies,
    addIntegration,
    pullMyData,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProIntegrations);



/** WEBPACK FOOTER **
 ** ./src/components/ProIntegrations.js
 **/